import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const Content = styled('div') `
	text-align: justify;
	#whiteLabelMobileSpeechBox_text {
		.ql-editor {
			all: unset;
			text-align: left;
		}
	}
`;
export const CustomStyleAcknowledgeSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer16};
`;
export const CustomStyledCheckbox = styled('div') `
	background-color: ${(props) => props.backgroundColor};
	box-shadow: ${Magnetic.boxShadow01};
	padding: ${Magnetic.spacer08} ${Magnetic.spacer16};
	border-radius: ${Magnetic.annotationBaseBorderRadius};
`;
export const CustomStyledActionControlsSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer12} ${Magnetic.spacer24};
	box-sizing: inherit;
`;
export const ActionButtonWrapper = styled('div') `
	display: flex;
	justify-content: center;
`;
export const SmallButton = styled('div') `
	margin: ${Magnetic.spacer06};
	width: 50%;
	text-align: center;
`;
export const LinkContainer = styled('div') `
	display: flex;
	justify-content: center;
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
	box-sizing: inherit;
`;
export const LinkButton = styled('div') `
	margin: ${Magnetic.spacer06};
	width: 50%;
	text-align: center;
	cursor: ${Magnetic.linkBaseCursor};
`;
export const DeclineStyledDiv = styled('div') `
	text-align: center;
	text-decoration: ${Magnetic.annotationBaseTextDecoration};
	margin-bottom: ${Magnetic.spacer16};
	-webkit-tap-highlight-color: transparent;
	font-size: ${Magnetic.baseFontSize};
	color: ${Magnetic.linkFontColor};
	span {
		cursor: ${Magnetic.linkBaseCursor};
	}
`;
export const StyledDivThankYou = styled('div') `
	font-size: 144px;
	text-align: center;
	color: ${(props) => props.thumbsUpColor};
	padding-top: ${Magnetic.spacer12};
`;
export const CarrierSectionContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer08};
`;
export const StyledDivRedirection = styled(Grid) `
	padding: ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer04} ${Magnetic.spacer24};
`;
//# sourceMappingURL=ScriptQuestionComponent.style.js.map